import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";
import { DispatchAction } from "../state/State.js";
import { uiActions } from "../state/UiReducer.js";

/**
 * @name SelectBase
 * @class SelectBase
 * @extends {ConnectedHTMLElement}
 * @description
 *
 */
export class SelectBase extends ConnectedHTMLElement {
  static observedAttributes = ["player"];

  constructor() {
    super();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    const player = this.getAttribute("player");
    const baseSelected = this.state[player].base !== undefined;
    const btn = this.querySelector(`#${player}-open-modal`);

    if (baseSelected) {
      btn.querySelector("p").innerText = "Change base";
    } else {
      btn.querySelector("p").innerText = "Select base";
    }
    if (newState.currentGame) {
      btn.classList.add("hidden");
    }
    if (!newState.currentGame) {
      btn.classList.remove("hidden");
    }
  }

  registerElementEvents() {
    const player = this.getAttribute("player");
    const openModalBtn = this.querySelector(`#${player}-open-modal`);
    openModalBtn.addEventListener("click", () => {
      DispatchAction(uiActions.toggleSelectBase, { show: true, player });
    });
    const openLeaderModalBtn = this.querySelector("#open-leader-modal");
    if (openLeaderModalBtn === null) return;
    openLeaderModalBtn.addEventListener("click", () => {
      DispatchAction(uiActions.toggleSelectLeader, { show: true, player });
    });
  }

  render() {
    const player = this.getAttribute("player");
    this.innerHTML = `<div class="w-full h-full flex flex-col items-center justify-center">
        <button
          class="btn btn-neutral btn-xl btn-wide flex flex-row items-center justify-center font-bold text-xl text-neutral-content mt-4"
            id="${player}-open-modal">
            <p class="mr-1 ">Select base</p>
            <img src="/assets/icons/deathstar.svg" width="32" height="32" alt="Death star" class="rounded-full bg-neutral p-1" />
          </button
        </button>
      </div>`;
  }

  connectedCallback() {
    this.render();
    this.registerElementEvents();
  }

  dispatchEvent(event) {
    return false;
  }
}
